import { SurveyState } from "./interface";

export const state: SurveyState = {
  SurveyById: {},
  SurveyAllId: []
};
